module.exports = __webpack_public_path__ + "img/hard-disc.3e281e5f.svg";